import { render, staticRenderFns } from "./historical-tvl.vue?vue&type=template&id=1c350a9b&scoped=true&"
import script from "./historical-tvl.vue?vue&type=script&lang=js&"
export * from "./historical-tvl.vue?vue&type=script&lang=js&"
import style0 from "./historical-tvl.vue?vue&type=style&index=0&id=1c350a9b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c350a9b",
  null
  
)

export default component.exports